import { render, staticRenderFns } from "./OnDemandButton.vue?vue&type=template&id=061b5bbc&scoped=true&"
import script from "./OnDemandButton.vue?vue&type=script&lang=js&"
export * from "./OnDemandButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061b5bbc",
  null
  
)

export default component.exports